import AuditAuthor from "../../../components/audit-author/AuditAuthor";
import HeaderPage from "../../../components/lines-managements/header/HeaderPage";
import DeleteModal from "../../../components/ui/DeleteModal";
import Table, { Row } from "../../../components/ui/table";
import Pagination from "../../../components/ui/table/Pagination";
import Can from "../../../components/users/permissions/Can";
import useCan from "../../../components/users/permissions/useCan";
import { useSearch } from "../../../hooks/useSearch";
import { IGTFSBlockedEntity } from "../../../interfaces/endpoints/IGTFS.types";
import { deleteGTFSBlock, getGTFSBlocks } from "../../../services/GTFS.service";

const COLUMNS = ["ID", "Lloji", "Entiteti ID", "Arsyeja", "Autori", "Veprimet"];
const PAGE_SIZE = 10;

const GTFSBlocks: React.FC = () => {
  const can = useCan("gtfs.create");
  const { response, loading, handlePageChange, page, setResponse } = useSearch(getGTFSBlocks, {
    withQuerySearch: true
  });

  return (
    <>
      <HeaderPage
        {...(can && {
          link: {
            to: "create",
            children: "Blloko entitet të ri",
            state: ["Menaxhimi i GTFS", "Bllokimet", "Shto"]
          }
        })}
      />
      <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
        <Table titles={COLUMNS} style="hover" loading={loading}>
          {!loading && response?.data?.result?.length ? (
            response.data.result.map((row: IGTFSBlockedEntity) => (
              <Row
                key={row.id}
                id={row.id}
                entityTypeName={row.entityTypeName}
                entityId={row.entityId}
                reason={
                  <span className="block max-w-md truncate" title={row.reason ?? ""}>
                    {row.reason || "-"}
                  </span>
                }
                auditAuthor={
                  <AuditAuthor
                    createdByName={row.auditAuthor.createdByName}
                    createdByLastName={row.auditAuthor.createdByLastName}
                    updatedByName={row.auditAuthor.updatedByName}
                    updatedByLastName={row.auditAuthor.updatedByLastName}
                    insertDate={row.auditAuthor.insertDate}
                    updateDate={row.auditAuthor.updateDate}
                  />
                }
                actions={
                  <Can permissions="gtfs.delete">
                    <DeleteModal
                      params={row.id}
                      title="Konfirmo zhbllokimin"
                      paragraph="Ky entitet do të përfshihet përsëri në GTFS feed."
                      handleDelete={deleteGTFSBlock}
                      successMessage="Entiteti u zhbllokua me sukses"
                      errorMessage="Zhbllokimi dështoi"
                      loadingMessage="Duke zhbllokuar..."
                      onSuccess={() => {
                        setResponse((prev) =>
                          prev
                            ? {
                                ...prev,
                                data: {
                                  ...prev.data,
                                  result: prev.data.result.filter(
                                    (el: { id: number }) => el.id !== row.id
                                  )
                                }
                              }
                            : null
                        );
                      }}
                    />
                  </Can>
                }
              />
            ))
          ) : (
            <tr>
              <td colSpan={COLUMNS.length} className="text-center py-4">
                {loading ? "Duke u ngarkuar..." : "Nuk u gjet asnjë bllokim"}
              </td>
            </tr>
          )}
        </Table>
        <Pagination
          onPageChange={handlePageChange}
          totalCount={response?.data?.totalCount || 0}
          length={response?.data?.result?.length || 0}
          page={page}
          pageSize={PAGE_SIZE}
        />
      </div>
    </>
  );
};

export default GTFSBlocks;
